import React, { useEffect } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { CustomSwitch } from '../../shared';
import { useDispatch, useSelector } from 'react-redux';
import { getFlowSettings, updateFlowSetting } from '../../../redux/thunks/adminSettingsThunk';
import { FlowSettingsSkeleton } from './skeleton';
import { actions } from '../../../redux/reducers/adminSettingsReducer';
import { CloseIcon } from '../../../assets';

const FlowSettings = (props) => {
  const { open, handleClose } = props;
  const { company } = useSelector((state) => state.company);
  const dispatch = useDispatch();
  const { isLoading, flowSettings } = useSelector((state) => state.adminSettings);
  const { flowSettingsData } = flowSettings;

  const handleFlow = (index) => {
    const updatedFlowSettings = flowSettingsData?.map((item, idx) => (idx === index ? { ...item, status: Number(!item.status) } : item));
    const updatedItem = updatedFlowSettings[index];
    dispatch(updateFlowSetting({ companyId: company.id, data: { key: updatedItem.flow, value: updatedItem.status } })).then(result=>{
      if(result?.payload?.status_code === 200){
        dispatch(actions.updateFlowSettings(updatedFlowSettings));
      }
    });
  };

  useEffect(() => {
    company.id && dispatch(getFlowSettings({ companyId: company.id }));
  }, [company.id]);

  const renderFlow = () => (
    <Grid container spacing={'24px'}>
      <Grid item xs={12}>
        <Grid container spacing={'24px'} className="flex-row">
          <Grid item xs={4}>
            <Box>
              <Typography className="text-sm-medium gray-700">
                Configuration of import-export Veeva flows
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box>
              {flowSettingsData?.map((flow, index) => (
                <CustomSwitch key={index} label={flow.title} checked={flow.status} onChange={() => handleFlow(index)} />
              ))}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  const renderModalData = () => (
    <Grid container className="modal_main">
      <Grid item xs={12}>
        <Box className="padding-24px">
          <Box className="flex-row-space-between pb-24px" >
            <Typography className='text-lg-medium gray-900'>
              Flow Settings
            </Typography>
            <Box className="cursor-pointer" onClick={handleClose}>
              <CloseIcon color="#98A2B3" width='12' height='12' />
            </Box>
          </Box>
          <Typography className="text-sm-medium gray-700">
            Configuration of import-export Veeva flows
          </Typography>
        </Box>
        <Box className="ml-17px padding-24px">
          <Box>
            {flowSettingsData?.map((flow, index) => (
              <CustomSwitch key={index} label={flow.title} checked={flow.status} onChange={() => handleFlow(index)} />
            ))}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );

  return open ? renderModalData() : isLoading ? <FlowSettingsSkeleton /> : renderFlow();
};

export default FlowSettings;